import { Component, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { DestroyNotifierComponent } from 'src/app/core/component/destroy/destroy-notifier.component';
import { FileAdapterService } from 'src/app/core/services/http/file/adapters/file-adapter.service';
import { FileService } from 'src/app/core/services/http/file/file.service';
import { FileStatus } from 'src/app/core/services/http/general/enums/file-status';
import { FileType } from 'src/app/core/services/http/general/enums/file-type';
import { UploadFile } from 'src/app/core/services/http/general/interfaces/upload-file';
import { RosterUploadFileType } from 'src/app/core/services/http/roster/enums/roster-upload-file-types';
import { ObservableWrapperService } from 'src/app/core/services/observable-wrapper/observable-wrapper.service';
import { clearFormControlsValidators } from 'src/app/core/utils/utils';
import { AutoCompleteItem } from 'src/app/shared/auto-complete/interfaces/autocomplete-item';
import { Authority } from '../../../../constants/authority';

@Component({
  selector: 'app-roster-students-upload',
  templateUrl: './roster-students-upload.component.html'
})
export class RosterStudentsUploadComponent extends DestroyNotifierComponent {
  @Input() form: UntypedFormGroup | undefined;

  authority = Authority;
  uploadFileTypes = RosterUploadFileType;
  files: AutoCompleteItem[] = [];
  clearFormControlsValidators = clearFormControlsValidators;
  protected readonly RosterUploadFileType = RosterUploadFileType;

  constructor(
    private fileService: FileService,
    private fileAdapterService: FileAdapterService,
    private observableWrapperService: ObservableWrapperService
  ) {
    super();
  }

  onSearchChange(filter: string): void {
    const flt = {
      filter,
      type: FileType.Rosters,
      'state[0]': FileStatus.Pending,
      'state[1]': FileStatus.Processed,
    };

    this.observableWrapperService.unsubscribeWrapper<UploadFile[]>(
      this.fileService.getAll(undefined, flt),
      this.destroyNotify,
      files => {
        this.files = this.fileAdapterService.uploadFileToAutoCompleteItem(files);
      }
    );
  }

  onSelectChange(item: AutoCompleteItem): void {
    this.form?.controls.file.setValue(item.value);
  }

  onUploadTypeChange(rosterUploadFileType: RosterUploadFileType): void {
    if (!this.form) {
      return;
    }

    this.form.controls.source.setValue(rosterUploadFileType, { emitEvent: false });
    this.clearFormControlsValidators(['file', 'items', 'itemsFromFile'], this.form);

    if (rosterUploadFileType === RosterUploadFileType.Automatic) {
      this.updateFileControlsValidators();
    } else {
      this.updateItemsControlsValidators();
    }
  }

  onRemove(autoCompleteItem: AutoCompleteItem): void {
    this.form?.controls.items.setValue(
      this.form?.controls.items.value.filter((e: AutoCompleteItem) => e.value !== autoCompleteItem.value)
    );
  }

  updateFileControlsValidators(): void {
    if (!this.form) {
      return;
    }

    this.form.controls.file.updateValueAndValidity();
  }

  updateItemsControlsValidators(): void {
    if (!this.form) {
      return;
    }

    this.form.controls.items.updateValueAndValidity();
  }

  getSortedItems(items: AutoCompleteItem[]): AutoCompleteItem[] {
    // sort by last name (secondLabel) with first name (firstLabel) if matching
    if (items) {
      items.sort(
        (a, b) => {
          let sortValueA;
          let sortValueB;
          if (a.extraLabels.secondLabel === b.extraLabels.secondLabel) {
             sortValueA = a.extraLabels.firstLabel;
             sortValueB = b.extraLabels.firstLabel;
          } else {
            sortValueA = a.extraLabels.secondLabel ?? '';
            sortValueB = b.extraLabels.secondLabel ?? '';
          }

          return sortValueA.toLowerCase().localeCompare(
            sortValueB.toLowerCase(), 'en', { sensitivity: 'base' }
          );
        }
      );
    }

    return items;
  }
}
